import { render, staticRenderFns } from "./NotWelcome.vue?vue&type=template&id=eccd81e4&scoped=true"
import script from "./NotWelcome.vue?vue&type=script&lang=js"
export * from "./NotWelcome.vue?vue&type=script&lang=js"
import style0 from "./NotWelcome.vue?vue&type=style&index=0&id=eccd81e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccd81e4",
  null
  
)

export default component.exports